/**
 * A simple function that tests if the device is touch capable
 */
function isTouchDevice () {
  return 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch;
};

module.exports = isTouchDevice;
